/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';
import { type OperationRequestBodyContent } from 'openapi-typescript-helpers';
import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

export type PatchTeamPathParams = NonNullable<operations['patchTeam']['parameters']['path']>;

export type PatchTeamQueryParams = NonNullable<operations['patchTeam']['parameters']['query']>;

export type PatchTeamRequestBody = OperationRequestBodyContent<operations['patchTeam']>;

export interface Input extends PatchTeamPathParams {
  apiVersion?: string;
  query?: PatchTeamQueryParams;
  body: PatchTeamRequestBody;
}

export async function patchTeam(
  { apiVersion, body, query, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().PATCH('/api/v2/teams/{teamKey}', {
    params: { path, query },
    body,
    headers: apiVersion ? mergeHeaders(headers, { 'LD-API-Version': apiVersion }) : headers,
    signal,
  });
}
